import React from "react";
//import RechargeDistribution from "../components/distribution/index";
import RechargeDistribution from "./distribution/rechargeSalesDistribution";
import Spinner from "../../components/presentationals/Spinner";
import { isEmptyObject } from "../../utils/common";
import OthersConnectivity from "./others/othersConnectivity";
import Sales from "./sales/index";

class RechargeSalesComponents extends React.Component {
  render() {
    if (
      this.props.getAllAPI &&
      !isEmptyObject(this.props.getAllAPI.data) &&
      this.props.getAllAPI.data.content &&
      this.props.getAllAPI.data.content[0]
    ) {
      const RSOtherModel =
        this.props.getAllAPI &&
        this.props.getAllAPI.data &&
        this.props.getAllAPI.data.content
          ? this.props.getAllAPI.data.content
              .filter(
                (item) => item.moduleName.toLowerCase() === "recharge sales"
              )[0]
              .modSecMasterTxDtos.filter(
                (section) => section.sectionName === "Other"
              )[0]
          : {};

      const sales =
        this.props.getAllAPI &&
        this.props.getAllAPI.data &&
        this.props.getAllAPI.data.content
          ? this.props.getAllAPI.data.content
              .filter(
                (item) => item.moduleName.toLowerCase() === "recharge sales"
              )[0]
              .modSecMasterTxDtos.filter(
                (section) => section.sectionName.toLowerCase() === "sales"
              )[0]
          : {};
      const distributionModel =
        this.props.getAllAPI &&
        this.props.getAllAPI.data &&
        this.props.getAllAPI.data.content
          ? this.props.getAllAPI.data.content
              .filter(
                (item) => item.moduleName.toLowerCase() === "recharge sales"
              )[0]
              .modSecMasterTxDtos.filter(
                (section) =>
                  section.sectionName.toLowerCase() === "distribution"
              )[0]
          : {};
      const moduleName =
        this.props.getAllAPI &&
        this.props.getAllAPI.data &&
        this.props.getAllAPI.data.content
          ? this.props.getAllAPI.data.content.filter(
              (item) => item.moduleName.toLowerCase() === "recharge sales"
            )[0].moduleName
          : "";

      let tstamp = null;
      if (this.props.timestamp && this.props.timestamp[moduleName]) {
        tstamp = this.props.timestamp[moduleName]["Recharge Sales"];
      }
      const rechargeModuleModel = this.props.getAllAPI.data.content.filter(
        (item) => item.moduleName.toLowerCase() === "recharge sales"
      )[0];
      return rechargeModuleModel?.isModuleActive === "Y" ? (
        <>
          {distributionModel && (
            <RechargeDistribution
              data={distributionModel}
              headerSelectedDateFrom={this.props.startDate}
              headerSelectedDateTo={this.props.endDate}
              moduleName={moduleName}
              filterValue={this.props.filterValue}
              timeStampArr={tstamp}
            />
          )}
          {sales?.isSectionActive === "Y" ? (
            <>
              <Sales
                data={sales.secTilesMasterTxDtos}
                filterValue={this.props.filterValue}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                moduleName={moduleName}
                timeStampArr={tstamp}
                section={sales.sectionName}
              />
            </>
          ) : null}
          {RSOtherModel && RSOtherModel.isSectionActive === "Y" ? (
            <OthersConnectivity
              componentToRender="Others"
              activationModel={RSOtherModel}
              data-cy="Others-connectivity"
              filterValue={this.props.filterValue}
              headerSelectedDateFrom={this.props.startDate}
              headerSelectedDateTo={this.props.endDate}
              timeStampArr={tstamp}
              moduleName={moduleName}
              section={RSOtherModel.sectionName}
            />
          ) : null}
        </>
      ) : null;
    } else {
      return <Spinner />;
    }
  }
}

export default RechargeSalesComponents;
